export const BACKEND_URL = "global.alto.exoware.xyz";
export const PUBLIC_KEY_HEX = "83a93d74819bc17b3f53258216b54ecba1a13e1257a0514241bdd79c7757b7c3921451021e7a592d12296076ef58a8b600179a2d006e8d73c337f2f3578a245c286f4af8921e4e4fca0b3375842c81cccd2b4ce7e875a5591fdded49c93a905c";
export const LOCATIONS: [[number, number], string][] = [
    [[37.7749, -122.4194], "San Francisco"],
    [[38.8339, -77.3074], "Ashburn"],
    [[53.3498, -6.2603], "Dublin"],
    [[35.6895, 139.6917], "Tokyo"],
    [[59.3293, 18.0686], "Stockholm"],
    [[19.076, 72.8777], "Mumbai"],
    [[-23.5505, -46.6333], "Sao Paulo"],
    [[50.1109, 8.6821], "Frankfurt"],
    [[37.5665, 126.978], "Seoul"],
    [[-33.8688, 151.2093], "Sydney"],
    [[37.7749, -122.4194], "San Francisco"],
    [[38.8339, -77.3074], "Ashburn"],
    [[53.3498, -6.2603], "Dublin"],
    [[35.6895, 139.6917], "Tokyo"],
    [[59.3293, 18.0686], "Stockholm"],
    [[19.076, 72.8777], "Mumbai"],
    [[-23.5505, -46.6333], "Sao Paulo"],
    [[50.1109, 8.6821], "Frankfurt"],
    [[37.5665, 126.978], "Seoul"],
    [[-33.8688, 151.2093], "Sydney"],
    [[37.7749, -122.4194], "San Francisco"],
    [[38.8339, -77.3074], "Ashburn"],
    [[53.3498, -6.2603], "Dublin"],
    [[35.6895, 139.6917], "Tokyo"],
    [[59.3293, 18.0686], "Stockholm"],
    [[19.076, 72.8777], "Mumbai"],
    [[-23.5505, -46.6333], "Sao Paulo"],
    [[50.1109, 8.6821], "Frankfurt"],
    [[37.5665, 126.978], "Seoul"],
    [[-33.8688, 151.2093], "Sydney"],
    [[37.7749, -122.4194], "San Francisco"],
    [[38.8339, -77.3074], "Ashburn"],
    [[53.3498, -6.2603], "Dublin"],
    [[35.6895, 139.6917], "Tokyo"],
    [[59.3293, 18.0686], "Stockholm"],
    [[19.076, 72.8777], "Mumbai"],
    [[-23.5505, -46.6333], "Sao Paulo"],
    [[50.1109, 8.6821], "Frankfurt"],
    [[37.5665, 126.978], "Seoul"],
    [[-33.8688, 151.2093], "Sydney"],
    [[37.7749, -122.4194], "San Francisco"],
    [[38.8339, -77.3074], "Ashburn"],
    [[53.3498, -6.2603], "Dublin"],
    [[35.6895, 139.6917], "Tokyo"],
    [[59.3293, 18.0686], "Stockholm"],
    [[19.076, 72.8777], "Mumbai"],
    [[-23.5505, -46.6333], "Sao Paulo"],
    [[50.1109, 8.6821], "Frankfurt"],
    [[37.5665, 126.978], "Seoul"],
    [[-33.8688, 151.2093], "Sydney"]
];
